import React from 'react';

const sectionStyle = {
    maxWidth: 600,
    margin: '32px auto',
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
    padding: '32px 20px',
    fontFamily: 'inherit',
    color: '#222',
};
const h1Style = {
    fontSize: 28,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: 32,
    letterSpacing: '-1px',
};
const h2Style = {
    fontSize: 20,
    fontWeight: 600,
    margin: '32px 0 12px 0',
    color: '#1a73e8',
};
const articleStyle = {
    fontSize: 16,
    lineHeight: 1.8,
    marginBottom: 18,
};
const strongStyle = { color: '#1a73e8', fontWeight: 600 };

const SensitiveInfoConsent = () => (
    <section style={sectionStyle}>
        <h1 style={h1Style}>민감정보 처리 동의서</h1>
        <article style={articleStyle}>
            Tobe Labs(이하 '회사'라고 합니다)는 개인정보보호법 등 관련 법령상의 개인정보보호 규정을 준수하며 회원의 개인정보보호에 최선을 다하고 있습니다. 회사는 개인정보보호법 제23조에 근거하여, 다음과 같이 민감정보 처리에 관한 동의를 받고자 합니다.<br /><br />
            다음의 내용을 자세히 읽어보신 후 동의 여부를 결정하여 주십시오.
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>처리하는 민감정보</h2>
            감정 상태<br />
            투자 성향 정보
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>민감정보의 처리목적</h2>
            "AI 투자 판단 리포트 생성을 위한 감정 상태 분석 및 투자 성향 진단"
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>민감정보의 보유기간</h2>
            정보주체의 회원탈퇴일까지
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>동의 거부 시 불이익 안내</h2>
            회원께서는 민감정보의 처리에 대한 동의를 거부할 권리가 있습니다. 다만, 동의를 거부할 경우서비스 이용제한등의 불이익이 있을 수 있습니다.
        </article>
        <article style={articleStyle}>
            본인은 본 동의서의 내용을 모두 이해하였으며, 민감정보의 처리에 관한 회원 권리 안내문에 관하여 자세한 설명을 듣고 내용에 동의합니다.<br /><br />
            그 외 사항은 회사의 개인정보처리방침에 따릅니다.
        </article>
        <div style={{ textAlign: 'right', marginTop: 40, color: '#888', fontSize: 15 }}>
            2025.07.22.
        </div>
    </section>
);

export default SensitiveInfoConsent; 